module.exports = __webpack_public_path__ + "img/16_87.db1e1172.png";